<script setup lang="ts">
import { computed } from 'vue'

export interface Props {
  numberOfHours?: number
  numberOfMinutes?: number
}
const props = withDefaults(defineProps<Props>(), {
  numberOfHours: null,
  numberOfMinutes: null,
})
const computedNumberOfHours = computed(() => {
  if (props.numberOfHours !== null) {
    return props.numberOfHours
  } else if (props.numberOfMinutes !== null) {
    return (props.numberOfMinutes - (props.numberOfMinutes % 60)) / 60
  }
  return null
})

const computedNumberOfMinutes = computed(() => {
  if (props.numberOfMinutes !== null) {
    return props.numberOfMinutes % 60
  }
  return null
})
</script>

<template lang="pug">
span(v-if="computedNumberOfHours || computedNumberOfMinutes")
  template(v-if="computedNumberOfHours") {{ computedNumberOfHours }}h
  template(v-if="computedNumberOfHours && computedNumberOfMinutes") &nbsp;
  template(v-if="computedNumberOfMinutes") {{ computedNumberOfMinutes }}m
span.color-outline-variant(v-else) empty
</template>
